module.exports = __webpack_public_path__ + "img/sider-wechat.5e643353.png";